<template>
  <div class="space-y-4">
    <TrafficKpis :kpis="stats?.kpis" :loading="loading" />

    <VisitorsOverTime :data="stats?.over_time || []" :bucket="stats?.range?.bucket" :loading="loading" />

    <div class="grid grid-cols-1 xl:grid-cols-2 gap-4">
      <ConversionFunnel
        :steps="stats?.funnel || []"
        :dead-end-rate="stats?.kpis?.dead_end_rate?.value ?? null"
        :loading="loading"
      />
      <TrafficSources :data="stats?.sources || []" :loading="loading" />
    </div>

    <div class="grid grid-cols-1 xl:grid-cols-3 gap-4">
      <div class="xl:col-span-2">
        <CountryMap :data="stats?.by_country || []" :loading="loading" />
      </div>
      <CountryTable :data="stats?.by_country || []" :loading="loading" />
    </div>

    <div class="grid grid-cols-1 xl:grid-cols-2 gap-4">
      <DeviceBreakdown :devices="stats?.devices || {}" :conversion="stats?.device_conversion || []" :loading="loading" />
      <PeakHours :data="stats?.peak_hours || []" :zone="stats?.range?.zone" :loading="loading" />
    </div>

    <div class="grid grid-cols-1 xl:grid-cols-2 gap-4">
      <DeadEndsCard :data="stats?.dead_ends || []" :loading="loading" />
      <AudienceDetails
        :landing-pages="stats?.landing_pages || []"
        :campaigns="stats?.campaigns || []"
        :locales="stats?.locales || []"
        :loading="loading"
      />
    </div>
  </div>
</template>

<script setup>
import TrafficKpis from './TrafficKpis.vue'
import VisitorsOverTime from './VisitorsOverTime.vue'
import ConversionFunnel from './ConversionFunnel.vue'
import TrafficSources from './TrafficSources.vue'
import CountryMap from './CountryMap.vue'
import CountryTable from './CountryTable.vue'
import DeviceBreakdown from './DeviceBreakdown.vue'
import PeakHours from './PeakHours.vue'
import DeadEndsCard from './DeadEndsCard.vue'
import AudienceDetails from './AudienceDetails.vue'

defineProps({
  stats:   { type: Object, default: null },
  loading: { type: Boolean, default: false },
})
</script>
